import { DEFAULT_PERMISSIONS } from '@/constants/constants';
import { StationsDropDown } from '@/Interface/analysisEmi';
import { DailyReport } from '@/Interface/dailyReport';
import { RegionAndCity } from '@/Interface/regionAndCity';
import { TariffTypeAndCompany } from '@/Interface/tariffs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PermissionsService } from '@services/permissions.service';
import { UtilityService } from '@services/utility.service';
import moment from 'moment';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { Subject, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-daily-report',
  templateUrl: './daily-report.component.html',
  styleUrls: ['./daily-report.component.scss']
})
export class DailyReportComponent implements OnInit, OnDestroy {
  public pageSizeControl = new FormControl(10);
  pageSize: number;
  pageToGo: number = 1;
  searchElement = '';
  serialNumberArray: Array<number> = [];
  next_page: number;
  current_page: number;
  previous_page: number;
  total_pages: number;
  total_items: number;
  private latestQueryParams: any = {};
  sortColumn: string = null;
  sortOrder: 'asc' | 'desc' = null;
  searchSubject: Subject<string> = new Subject();
  loader: boolean = false
  isLoadingTableInner: boolean = false

  public pageRecordOptions = [
    { value: '10', label: '10' },
    { value: '25', label: '25' },
    { value: '50', label: '50' },
    { value: '100', label: '100' },
    { value: '200', label: '200' },
  ];

  public citiesList: TariffTypeAndCompany[] = [];
  public selectedId: number
  allPlantList: StationsDropDown;
  selectedDate: Date = null;
  datePickerConfig: Partial<BsDaterangepickerConfig> = {
    showWeekNumbers: false,
    dateInputFormat: 'DD/MM/YYYY',
    adaptivePosition:true,
  };
  plantDetails: DailyReport | null = null;
  dailyReportForm: FormGroup;
  subscribeForm: FormGroup;
  modalRef: NgbModalRef | null = null;
  isDownloading: boolean;
  downtimeList: { label: string, value: string }[] = [];
  permissions = { ...DEFAULT_PERMISSIONS };
  permissionsReady: boolean = false;

  isLoadingSubscription: boolean = false;
  ownedPlants: any[] = [];
  subscribedPlants: any[] = [];
  existingSubscription: any = null;
  currentUserId: number | null = null;
  showUnsubscribeConfirm: boolean = false;
  availablePlants: any[] = [];

  constructor(private modalService: NgbModal,
    private _utilityService: UtilityService,
    private toaster: ToastrService,
    private formBuilders: FormBuilder,
    private permService: PermissionsService,
  ) { }

  ngOnInit(): void {
    const userDetail: any = this._utilityService.decodeUserCode();
    this.currentUserId = userDetail.user_id
    this.forminit();
    this.getPlantsDropDown();
    this.initComponent();
    // this.searchSubject.pipe(debounceTime(300)).subscribe((searchTerm: string) => {
    //   this.searchElement = searchTerm;
    //   this.updateQueryParams({ search: this.searchElement });
    // });
    this.generateDowntimeOptions();
  }
  async initComponent() {
    this.loader = true
    await this.getComponentPermissions();

    if (this.permissions.canView) {
      this.getTableData();
    }
    setTimeout(() => {
      this.loader = false;
    }, 250);
  }

  async getComponentPermissions() {
    const url = this.permService.getCurrentUrl();
    // const menuFromLocal = this.permService.loadMenuFromLocalStorage();
    const menuFromLocal = await this.permService.waitForMenuInLocalStorage();

    const matchedMenu = this.permService.findMenuPermissions(menuFromLocal, url);

    this.permissions = matchedMenu
      ? {
        canAdd: !!matchedMenu.canAdd,
        canEdit: !!matchedMenu.canEdit,
        canView: !!matchedMenu.canView,
        canDelete: !!matchedMenu.canDelete
      }
      : { ...DEFAULT_PERMISSIONS };

    this.permissionsReady = true;
  }
  get hasAnyActionPermission(): boolean {
    return (
      this.permissionsReady &&
      (this.permissions.canView ||
        this.permissions.canEdit ||
        this.permissions.canDelete)
    );
  }

  private generateDowntimeOptions() {
    for (let h = 0; h < 24; h++) {
      for (let m = 0; m < 60; m += 5) { // increment by 5 minutes for better usability
        const hours = h.toString().padStart(2, '0');
        const minutes = m.toString().padStart(2, '0');
        this.downtimeList.push({
          label: `${hours}h ${minutes}m`,
          value: `${hours}:${minutes}`
        });
      }
    }
  }

  forminit() {
    this.dailyReportForm = this.formBuilders.group({
      downtime: [null],
      remarks: [null],
    })
    this.subscribeForm = this.formBuilders.group({
      plant: [null, Validators.required],
    })
  }

  openEditPopUp(item: RegionAndCity, contentupdate: any) {
    this.selectedId = item.id;
    this.modalService.open(contentupdate);
  }

  openDownloadPopup(content: any) {
    const stationCode = this.latestQueryParams['stationCode'] || null;
    const date = this.latestQueryParams['date'] || null;
    if (stationCode && date) {
      this.modalRef = this.modalService.open(content, { centered: true });
    } else {
      this.toaster.warning('Please select both Station Code and Date before downloading.');
    }
  }
  // openModal(content: any) {
  //   this.getPlants();
  //   this.getSubscription();
  //   this.modalRef = this.modalService.open(content, { centered: true });
  // }

  getPlants() {
    this._utilityService.fetchStationInfo(null, null).subscribe((res) => {
      if (res) {
        this.ownedPlants = res.data || [];
      }
    });
  }
  private updateQueryParams(paramsToUpdate: any): void {
    this.latestQueryParams = {
      ...this.latestQueryParams,
      ...paramsToUpdate
    };

    if (this.latestQueryParams.search === '') {
      this.latestQueryParams.search = null;
    }
    if (this.latestQueryParams.page === 1) {
      this.latestQueryParams.page = null;
    }

    if (this.latestQueryParams.size === 10) {
      this.latestQueryParams.size = null;
    }
    if (this.latestQueryParams.size === 10) {
      this.latestQueryParams.size = null;
    }
    if (this.latestQueryParams.sort === null) {
      delete this.latestQueryParams.sort;
    }

    if (this.latestQueryParams.column === null) {
      delete this.latestQueryParams.column;
    }
    if (this.latestQueryParams.stationCode === null) {
      delete this.latestQueryParams.stationCode;
    }
    if (this.latestQueryParams.date === null) {
      delete this.latestQueryParams.date;
    }

    if (this.latestQueryParams.page === 1 || (this.latestQueryParams.page && (this.latestQueryParams.search))) {
      if (this.latestQueryParams.page > 1) {
        this.latestQueryParams.page = paramsToUpdate.page;
        if (this.latestQueryParams.size > 10) {
          this.latestQueryParams.size = paramsToUpdate.size;
        }
      } else {
        this.latestQueryParams.page = null;
      }
    }
    if (!this.next_page && (paramsToUpdate.size || paramsToUpdate.search)) {
      // Only include size or search in the query params
      this.latestQueryParams = {
        size: paramsToUpdate.size || null,
        search: paramsToUpdate.search || null
      };
    }
    this.getTableData();
  }
  closeModal() {
    if (this.modalRef) {
      this.modalRef.close('Closed');
    }
  }

  downloadReport(): void {
    const stationCode = this.latestQueryParams['stationCode'] || null;
    const date = this.latestQueryParams['date'] || null;
    const remarks = this.dailyReportForm.get('remarks')?.value || null;
    const downtime = this.dailyReportForm.get('downtime')?.value || null;

    if (stationCode && date) {
      this.isDownloading = true;  // start loader
      const body = {
        station_code: stationCode,
        date: date,
        remarks: remarks,
        average_down_time: downtime
      };
      this._utilityService
        .downloadDailyReport(body)
        .subscribe({
          next: (res: Blob) => {
            const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = `Daily_Report_${stationCode}_${date}.xlsx`;
            a.click();

            window.URL.revokeObjectURL(url);
            this.isDownloading = false; // stop loader
            this.closeModal();
            this.resetForm();
          },
          error: () => {
            // this.resetForm();
            this.isDownloading = false; // stop loader on error
            this.toaster.error('Failed to download report. Please try again.');
          }
        });
    } else {
      this.toaster.warning(
        'Please select both Station Code and Date before downloading.',
        '',
        { timeOut: 5000 }
      );
    }
  }




  // const name = this.latestQueryParams['search'] || this.searchElement;
  // const page = this.latestQueryParams['page'] ? +this.latestQueryParams['page'] : 1;
  // const size = this.latestQueryParams['size'] ? +this.latestQueryParams['size'] : 10;
  // const sort = this.latestQueryParams['sort'] || null;
  // const column = this.latestQueryParams['column'] || null;'
  private getTableData(): void {
    const stationCode = this.latestQueryParams['stationCode'] || null;
    const date = this.latestQueryParams['date'] || null;
    if (stationCode && date) {
      this.getDailyReport(stationCode, date);
    }
    else {
      this.plantDetails = null;
    }
  }

  getDailyReport(stationCode: string | null, date: string | null): void {
    this.isLoadingTableInner = true;
    this.plantDetails = null;

    this._utilityService.fetchDailyReport(stationCode, date).subscribe({
      next: (res: any) => {
        this.plantDetails = res;
        this.isLoadingTableInner = false; // Stop loader after success
      },
      error: (err: any) => {
        console.error('Error fetching daily report:', err);
        this.isLoadingTableInner = false; // Stop loader on error too
        // Optional: Show a toast/snackbar or set a message for UI
      }
    });
  }

  public searchData(event: Event): void {
    this.searchElement = (event.target as HTMLInputElement)?.value || '';
    this.searchSubject.next(this.searchElement);
  }

  goToPage(page: number): void {
    if (page >= 1 && page <= this.total_pages) {
      this.updateQueryParams({ page: page });
    }
  }

  navigatePage(direction: string): void {
    if (direction === 'prev' && this.current_page > 1) {
      this.goToPage(this.current_page - 1);
    } else if (direction === 'next' && this.next_page !== null) {
      this.goToPage(this.current_page + 1);
    }
  }

  // Add a method to navigate to the entered page
  navigateToPage(): void {
    if (this.pageToGo >= 1 && this.pageToGo <= this.total_pages) {
      this.goToPage(this.pageToGo);
    }
  }

  public changePageSize(): void {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.pageSize = this.pageSizeControl.value!;
    this.updateQueryParams({ size: this.pageSize })
  }

  enablePagination() {
    const linkElement = document.getElementById('prevPage');

    if (this.previous_page === null) {
      linkElement.setAttribute('disabled', 'true');
      linkElement.style.pointerEvents = 'none';
      linkElement.style.color = 'gray';
      linkElement.addEventListener('click', (event) => {
        event.preventDefault();
      });
    } else {
      linkElement.removeAttribute('disabled');
      linkElement.style.pointerEvents = 'auto';
      linkElement.style.color = '';
      linkElement.removeEventListener('click', (event) => {
        event.preventDefault();
      });
    }
  }
  deleteCity(id: number) {
    if (id) {
      this._utilityService.deleteRegionAndCity(id).pipe(
        catchError(error => {
          if (error.status === 400) {
            this.toaster.error(error.error.message || 'Bad request');
          } else {
            this.toaster.error('An error occurred. Please try again later.');
          }
          this.resetForm();
          return throwError(() => error);
        })
      ).subscribe(() => {
        // Success path — runs on 200, 204, etc.
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'City deleted successfully',
          showConfirmButton: false,
          timer: 1000
        });
        this.getTableData();
      });
    }
  }
  deleteTariffType(id: number, content: any) {
    this.modalService.open(content, { centered: true }).result.then(
      (result) => {
        if (result === 'confirm') {
          this.deleteCity(id)
        }
      },
      (reason) => {
        console.log('Modal dismissed:', reason);
      }
    );
  }
  public selectPlants(plants: any): void {
    if (plants) {
      this.updateQueryParams({ stationCode: plants.stationCode });
    } else {
      // If we're resetting, remove stationCode instead of sending null
      this.updateQueryParams({ stationCode: null });
    }
  }
  getPlantsDropDown() {
    this._utilityService.getStationsDropDown().subscribe((res) => {
      if (res) {
        this.allPlantList = res.data;
      }
    });
  }
  onRangeChange(date: Date): void {
    if (date) {
      this.selectedDate = date; // Store the selected month only
      const formattedFromDate = moment(date).format('YYYY-MM-DD');
      this.updateQueryParams({ date: formattedFromDate, });
    } else {
      this.updateQueryParams({ date: null, });
    }
  }

  clearDateRange(): void {
    if (this.selectedDate) {
      this.selectedDate = null
      this.updateQueryParams({ date: null })
    }
  }
  openModal(content: any) {
    this.isLoadingSubscription = true;
    this.modalRef = this.modalService.open(content, { centered: true });
    this._utilityService.fetchStationInfo(null, null).subscribe((res) => {
      if (res) {
        this.ownedPlants = res.data || [];
        this.updateAvailablePlants(); // add this
        this.getSubscription(); // call after plants are ready
      }
    });
  }
  getSubscription(): void {
    this._utilityService.getSubscription(this.currentUserId, 'DAILY').subscribe({
      next: (res: any) => {
        this.existingSubscription = res;
        this.subscribedPlants = (res.plants || [])
          .map((id: number) => (this.ownedPlants as any[])?.find(p => p.id === id))
          .filter(Boolean);
        this.updateAvailablePlants();

        this.isLoadingSubscription = false;
      },
      error: () => {
        this.existingSubscription = null;
        this.subscribedPlants = [];
        this.updateAvailablePlants();
        this.isLoadingSubscription = false;
      }
    });
  }
  // getSubscription(): void {
  //   this._utilityService.getSubscription(this.currentUserId).subscribe({
  //     next: (res: any) => {
  //       this.existingSubscription = res;
  //       this.subscribedPlants = res.plants || [];
  //     },
  //     error: () => {
  //       this.existingSubscription = null;
  //       this.subscribedPlants = [];
  //     }
  //   });
  // }
  onPlantSelect(plant: any): void {
    if (!plant) return;
    const alreadyAdded = this.subscribedPlants.find(p => p.id === plant.id);
    if (!alreadyAdded) {
      this.subscribedPlants.push(plant);
      this.updateAvailablePlants();
    }
    this.subscribeForm.get('plant').setValue(null);
  }
  // onPlantSelect(plant: any): void {
  //   if (!plant) return;
  //   const alreadyAdded = this.subscribedPlants.find(p => p.id === plant.id);
  //   if (!alreadyAdded) {
  //     this.subscribedPlants.push(plant);
  //     console.log('Subscribed Plants:', this.subscribedPlants);
  //   }
  //   this.subscribeForm.get('plant').setValue(null);
  // }

  // removePlant(plant: any): void {
  //   this.subscribedPlants = this.subscribedPlants.filter(p => p.id !== plant.id);
  //   const plantIds = this.subscribedPlants.map(p => p.id);

  //   const body = {
  //     user: this.currentUserId,
  //     report_type: 'DAILY',
  //     plants: plantIds
  //   };

  //   if (this.existingSubscription) {
  //     this._utilityService.updateSubscription(body).subscribe({
  //       next: () => this.toaster.success(`${plant.stationName} removed`),
  //       error: () => this.toaster.error('Failed to remove plant')
  //     });
  //   }
  // }
  removePlant(plant: any): void {
  const wasFromBackend = this.existingSubscription?.plants?.includes(plant.id);
  this.subscribedPlants = this.subscribedPlants.filter(p => p.id !== plant.id);
  this.updateAvailablePlants();

  if (wasFromBackend) {
    const plantIds = this.subscribedPlants.map(p => p.id);

    // If no plants left, treat as unsubscribed
    if (plantIds.length === 0) {
      const body = { user: this.currentUserId, report_type: 'DAILY' };
      this._utilityService.deleteSubscription(body).subscribe({
        next: () => {
          this.existingSubscription = null;
          this.toaster.success(`${plant.stationName} removed`);
        },
        error: () => {
          this.subscribedPlants.push(plant);
          this.updateAvailablePlants();
          this.toaster.error('Failed to remove plant');
        }
      });
      return;
    }

    const body = {
      user: this.currentUserId,
      report_type: 'DAILY',
      plants: plantIds
    };
    this._utilityService.updateSubscription(body).subscribe({
      next: (res) => {
        this.existingSubscription = res;
        this.toaster.success(`${plant.stationName} removed`);
      },
      error: () => {
        this.subscribedPlants.push(plant);
        this.updateAvailablePlants();
        this.toaster.error('Failed to remove plant');
      }
    });
  }
}

  saveSubscription(): void {
    this.isDownloading = true;
    const plantIds = this.subscribedPlants.map(p => p.id);
    if (!plantIds.length) {
      this.toaster.warning('Please select at least one plant.');
      return;
    }

    const body = {
      user: this.currentUserId,
      plants: plantIds,
      report_type: 'DAILY'
    };

    const request$ = this.existingSubscription
      ? this._utilityService.updateSubscription(body)
      : this._utilityService.createSubscription(body);

    request$
      .pipe(
        finalize(() => {
          this.isDownloading = false;
        })
      ).subscribe({
        next: (res) => {
          this.existingSubscription = res;
          this.toaster.success('Subscription saved successfully.');
          this.closeModal();
        },
        error: (err) => {
          this.toaster.error(err?.error?.error || 'Failed to save subscription.');
        }
      });
  }

  unsubscribe(): void {
    // if (!this.existingSubscription) {
    //   this.toaster.warning('No active subscription found.');
    //   return;
    // }

    const body = { user: this.currentUserId, report_type: 'DAILY' };

    this._utilityService.deleteSubscription(body).subscribe({
      next: () => {
        this.toaster.success('Unsubscribed successfully.');
        this.existingSubscription = null;
        this.subscribedPlants = [];
        this.showUnsubscribeConfirm = false;

        this.closeModal();
      },
      error: () => this.toaster.error('Failed to unsubscribe.')
    });
  }
  getAvailablePlants(): any[] {
    return (this.ownedPlants as any[] || [])
      .filter(p => !this.subscribedPlants.find(sp => sp.id === p.id));
  }
  updateAvailablePlants(): void {
    this.availablePlants = (this.ownedPlants as any[] || [])
      .filter(p => !this.subscribedPlants.find(sp => sp.id === p.id));
  }
  resetForm() {
    this.dailyReportForm.reset();
    this.subscribeForm.reset();
    this.subscribedPlants = [];
    this.existingSubscription = null;
    this.showUnsubscribeConfirm = false;
    this.availablePlants = [];

  }

  confirmUnsubscribe(): void {
    this.showUnsubscribeConfirm = true;
  }

  cancelUnsubscribe(): void {
    this.showUnsubscribeConfirm = false;
  }
  ngOnDestroy(): void {
    if (this.modalRef) {
      this.modalRef.close('Closed');
    }
  }
}
